import { Button as MUIButton, CircularProgress } from "@mui/material";
import { makeStyles } from '@material-ui/core/styles';
import { colors } from "../constants/colors";
import { useTheme } from "@mui/material/styles";

const ButtonField = ({
  label,
  onClick,
  type = "button",
  disabled = false,
  isLoading = false,
  startIcon = null,
  endIcon = null,
  fullWidth = false,
  variant = "contained",
  color = "primary",
  size = "medium",
  sx,
  ...rest
}) => {
  const theme = useTheme();
const useStyles = makeStyles((theme) => ({
    button: {
      margin: `${theme.spacing(1)} !important`,
      backgroundColor: `${colors.orange} !important`,
      color: `${colors.white} !important`,
      minWidth: "150px !important",
      textTransform: "capitalize !important",

      "&:hover": {
        backgroundColor: `${colors.orange} !important`,
        opacity: "0.8 !important",
      },
      "&.Mui-disabled": {
        backgroundColor: `${colors.disabledBg} !important`,
        color: `${colors.textDisabledMid} !important`,
      },
    },
    outlineButton: {
      border: `${"1px solid" + colors.orange} !important`,
      color: `${colors.orange} !important`,
      "&:hover": {
        backgroundColor: `${colors.orange} !important`,
        opacity: "0.8 !important",
        color: `${colors.white} !important`,
      },
    },
}));
  const classes = useStyles();
  return (
    <MUIButton
      type={type}
      onClick={onClick}
      disabled={disabled || isLoading}
      startIcon={startIcon}
      endIcon={endIcon}
      fullWidth={fullWidth}
      variant={variant}
      className={classes.button}
      color={color}
      size={size}
      sx={sx}
      {...rest}
    >
      {isLoading ? <CircularProgress size={20} color="inherit" /> : label}
    </MUIButton>
  );
};

export default ButtonField;
